import React from 'react';
import { useOrg } from '../contexts/OrgContext';
import { Building2 } from 'lucide-react';

const OrgSelector = () => {
  const { needsOrgSelection, orgList, selectOrg, orgLoading } = useOrg();

  if (!needsOrgSelection || orgLoading) return null;

  return (
    <div data-testid="org-selector-overlay" className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div data-testid="org-selector-dialog" className="bg-white dark:bg-zinc-900 rounded-xl shadow-2xl border border-zinc-200 dark:border-zinc-700 p-6 w-full max-w-md mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-blue-50 dark:bg-blue-900/30">
            <Building2 className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">Select Organisation</h2>
            <p className="text-sm text-zinc-500 dark:text-zinc-400">You belong to multiple organisations. Choose one to continue.</p>
          </div>
        </div>

        <div className="space-y-2 max-h-64 overflow-y-auto">
          {orgList.map(org => (
            <button
              key={org.org_id}
              data-testid={`org-option-${org.org_id}`}
              onClick={() => selectOrg(org.org_id)}
              className="w-full flex items-center gap-3 p-3 rounded-lg border border-zinc-200 dark:border-zinc-700 hover:bg-zinc-50 dark:hover:bg-zinc-800 transition-colors text-left"
            >
              {org.logo_url ? (
                <img src={org.logo_url} alt="" className="w-8 h-8 rounded-md object-cover" />
              ) : (
                <div className="w-8 h-8 rounded-md bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center text-sm font-medium text-zinc-600 dark:text-zinc-300">
                  {(org.name || '?')[0].toUpperCase()}
                </div>
              )}
              <div>
                <div className="text-sm font-medium text-zinc-900 dark:text-zinc-100">{org.name || org.org_id}</div>
                {org.slug && <div className="text-xs text-zinc-400">{org.slug}</div>}
              </div>
            </button>
          ))}
        </div>

        {orgList.length === 0 && (
          <p className="text-sm text-zinc-500 text-center py-4">No organisations found.</p>
        )}
      </div>
    </div>
  );
};

export default OrgSelector;
